module.exports = __webpack_public_path__ + "static/media/luma-banner-75.958bd9bb.png";